import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as homepageSlice from "../../../../redux/slices/homepageSlice";
import * as locationSlice from "../../../../redux/slices/locationSlice";
import { toast } from "react-toastify";
import { imageBaseUrl } from "../../../../helper";
import DataTable from "react-data-table-component"; // Import DataTable
import DeleteModal from "../../components/DeleteModal";
import { Trash } from "feather-icons-react/build/IconComponents";
import { NotePencil } from "@phosphor-icons/react";

const CustomizeLocation = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const fileInputRef = useRef(null);
  const [sortNumber, setSortNumber] = useState(undefined);
  const [showEditTempleModal, setShowEditTempleModal] = useState(false);
  const [imageId, setImageId] = useState(undefined);
  const [bannerType, setBannerType] = useState("Image"); // New state for banner type
  const [selectedVideo, setSelectedVideo] = useState();
  const [thumbnail, setThumbnail] = useState();
  const [form, setForm] = useState({});
  const dispatch = useDispatch();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletableId, setDeletableId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [locationId, setLocationId] = useState();

  const { locationData, loading } = useSelector((state) => state.locationSlice);

  // Modal state for adding temple
  const [showAddTempleModal, setShowAddTempleModal] = useState(false);

  console.log(locationData, "locationData");

  useEffect(() => {
    if (!showEditTempleModal) {
      setSortNumber(0);
    }
    dispatch(locationSlice.getLocation());
  }, [dispatch]);

  useEffect(() => {
    if (!showEditTempleModal) {
      setSortNumber(0);
    }
  }, [showEditTempleModal]);

  // Handle delete
  const handleDelete = (locationId) => {
    setDeleteModal(true);
    setDeletableId(locationId);
  };

  const handleDeleteImage = async () => {
    await dispatch(locationSlice.destroyDestination(deletableId));
    dispatch(locationSlice.getLocation());
    setDeleteModal(false);
  };

  // DataTable columns definition
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "60px",
    },
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "Destination Name",
      selector: (row) => row?.destination_name || "-",
      sortable: true,
    },
    {
      name: "Latitude",
      selector: (row) => row?.latitude || "-",
      sortable: true,
    },
    {
      name: "Longitude",
      selector: (row) => row?.longitude || "-",
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex">
          <div className="delete">
            <Trash onClick={() => handleDelete(row.id)} size={19} />
          </div>
          <div
            className="edit ml-1"
            onClick={(e) => {
              handleOnEditClick(row.id);
              setShowAddTempleModal(true);
              setIsEdit(true);
            }}
          >
            <NotePencil size={18} />
          </div>
        </div>
      ),
    },
  ];

  const handleOnEditClick = (id) => {
    const data = locationData?.find((h) => h?.id === id);
    setLocationId(data?.id);
    setForm({
      ...form,
      destination_name: data?.destination_name,
      lat: data?.latitude,
      long: data?.longitude,
    });
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    const { destination_name, lat, long } = form;
    formData.append("destination_name", destination_name);
    formData.append("lat", lat);
    formData.append("long", long);

    await dispatch(locationSlice.updateLocation(locationId, formData, setForm));
    setSelectedImage(null);
    setPreviewImage(null);
    setShowAddTempleModal(false);
    await dispatch(locationSlice.getLocation());
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();

    const { destination_name, lat, long } = form;

    if (!destination_name) {
      toast("Please enter destination");
      return;
    }
    if (!lat) {
      toast("Please enter latitude");
      return;
    }
    if (!long) {
      toast("Please enter longitude");
      return;
    }

    formData.append("destination_name", destination_name);
    formData.append("lat", lat);
    formData.append("long", long);

    await dispatch(locationSlice.storeDestination(formData, setForm));
    setShowAddTempleModal(false);
    dispatch(locationSlice.getLocation());
  };

  return (
    <>
      <h5 className="mb-4"> Customize Location</h5>

      <Row className="mt-4">
        <Col
          md={12}
          className="d-flex justify-content-between align-items-center"
        >
          <h6>Added locations:</h6>
          <Button
            style={{
              backgroundColor: "#e8783d",
              border: "none",
              marginBottom: "1vh",
            }}
            onClick={() => {
              setIsEdit(false);
              setForm({});
              setShowAddTempleModal(true);
            }}
          >
            Add Location
          </Button>
        </Col>
      </Row>

      {loading ? (
        <div className="w-100 d-flex">
          <div
            className="spinner-border text-primary mx-auto"
            role="status"
          ></div>
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={(locationData?.length && locationData) || []}
          pagination
          highlightOnHover
          pointerOnHover
        />
      )}

      <DeleteModal
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        handleDelete={handleDeleteImage}
        name={"Image"}
      />

      {/* Add Banner Modal */}
      <Modal
        show={showAddTempleModal}
        onHide={() => setShowAddTempleModal(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        dialogClassName="modal-90w" // Optional: To make the modal wider
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isEdit ? "Update" : "Add"} Destination Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Enter Destination</Form.Label>
              <Form.Control
                type="text"
                value={form?.destination_name}
                onChange={(e) =>
                  setForm({ ...form, destination_name: e.target.value })
                }
                placeholder="Enter destination"
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>
            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Lat</Form.Label>
              <Form.Control
                type="number"
                value={form?.lat}
                onChange={(e) => setForm({ ...form, lat: e.target.value })}
                placeholder="Enter sort number"
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>
            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Long</Form.Label>
              <Form.Control
                type="number"
                value={form?.long}
                onChange={(e) => setForm({ ...form, long: e.target.value })}
                placeholder="Enter sort number"
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAddTempleModal(false)}
          >
            Close
          </Button>
          {isEdit ? (
            <Button variant="primary" type="submit" onClick={handleUpdate}>
              Update Location
            </Button>
          ) : (
            <Button variant="primary" type="submit" onClick={handleSubmit}>
              Save Location
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomizeLocation;
